angular.module 'zc.masterApi'

.factory "MasterAccessStats", ($q, FacadeV2) ->


  class MasterAccessStats

    @find: (query, opts={}) ->
      $q (resolve, reject) ->
        query ||= {}
        unless query._id or (query.apikey and query.start_at)
          return reject "no _id or apikey/start_at provided"

        # TODO:
        # Limit the apikey count per request, ie. do the requests in batches.
        # Currently the request fails in this page because it tries to get data for 
        # all of our apikeys at once...
        # https://aideal-admin.appier.com/admin/master/projects?visible_group=stats

        FacadeV2.request "/master/access_stats/daily",
          params:
            match: query
            sort: '-start_at'
            limit: opts.limit || undefined
        .then (res) ->
          if res.status != 200
            return reject res.data.error
          resolve res.data

    @aggregate: (paths, query) ->
      params = {}
      params.match = query.match
      params.pipeline = query.pipeline

      FacadeV2.request "/master/access_stats/#{paths.dimension}/aggregate", {
        params: params
      }
      .then (res) ->
        res.data

  MasterAccessStats



// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/facade/master_access_stats.service.coffee